const STATS = [
  { value: "$14,200", label: "Median Monthly Gain", accent: true },
  { value: "30 Sec", label: "Effort Per Claim", accent: false },
  { value: "88%", label: "Dispute Success Rate", accent: false },
  { value: "3 Mins", label: "First Draft Speed", accent: false },
];

const Stats = () => (
  <section
    data-testid="benchmarks-section"
    className="py-16 sm:py-24 border-b border-[#E7E5E4] bg-white"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="mb-10 max-w-2xl">
        <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display">
          More money back. Less time spent.
        </h2>
        <p className="text-sm text-stone-600 mt-2">
          What shops in the private beta are seeing.
        </p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((stat, i) => (
          <div
            key={stat.label}
            data-testid={`stat-card-${i + 1}`}
            className={`border-l-2 pl-4 ${
              stat.accent ? "border-[#9A3412]" : "border-stone-300"
            }`}
          >
            <div className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mb-1">
              {stat.value}
            </div>
            <div className="text-xs font-bold uppercase tracking-wider text-stone-500">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
